'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./progress.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _proptypesValidation = require('../../utils/proptypes-validation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Progress(_ref) {
  var className = _ref.className,
      color = _ref.color,
      percent = _ref.percent,
      props = _objectWithoutProperties(_ref, ['className', 'color', 'percent']);

  var classes = (0, _classnames2.default)('progress', className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, props),
    _react2.default.createElement('div', {
      className: 'progress__indicator progress__indicator--color-' + color,
      style: { WebkitTransform: 'translateX(' + (-100 + percent) + '%)', transform: 'translateX(' + (-100 + percent) + '%)' }
    })
  );
}

Progress.propTypes = {
  className: _propTypes2.default.string,
  color: _propTypes2.default.oneOf(['blue', 'green', 'orange', 'red']),
  percent: _proptypesValidation.inRange.bind(null, 0, 100)
};

Progress.defaultProps = {
  color: 'blue',
  percent: 0
};

exports.default = Progress;